;(function () {
	'use strict';

	window.fuckIE = !!window.MSInputMethodContext && !!document.documentMode;

	$.ajaxSetup({
		headers: {
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		}
	});
	
	// Include js-modules
	var req = require.context("./modules", true, /_[^_].*\.(js)$/);
	req.keys().forEach(function(key){
		req(key);
	});
	
})();
